import { useMutation } from '@apollo/client';
import { gqlTypes } from '../types';
import { resolvePetAdoptionTransferMutation } from '../graphql-operations/PetAdoptionTransfer';

type ResolvePetAdoptionTransferVars = { input: gqlTypes.ResolvePetAdoptionTransferInput };

export function useResolvePetAdoptionTransfer() {
  const [mutate, state] = useMutation<any, ResolvePetAdoptionTransferVars>(resolvePetAdoptionTransferMutation);

  const resolveAdoptionTransfer = (input: gqlTypes.ResolvePetAdoptionTransferInput) => mutate({ variables: { input } });

  return { resolveAdoptionTransfer, ...state };
}
